import React from 'react'
import Product from 'components/Product'

export default Component => props => (
  <Product
    render={({ product }) => <Component product={product} {...props} />}
  />
)



// WEBPACK FOOTER //
// ./src/components/withProduct.js